<template>
  <div class="training-joined-detail-component">
    <template v-if="training.id > 0"
    >
      <bottom-bar-layout show-bar
                         :bar-height="160"
                         :shadow="true"
                         :is-show-guide-popup="false"
      >
        <training-header :title="training.title"
                         :start-time="render.startTime"
                         :is-complete="render.isComplete"
                         :finish-count="count.finish"
                         :continue-count="count.continue"
                         :read-count="count.read"
                         :levels-length="levels.length"
        />

        <ym-tabs v-model="tabSelected"
                 size="medium"
                 :border="false"
        >
          <ym-tab name="calendar" title="打卡日历">
            <calendar v-if="levels.length > 0"
                      :start-time="render.startTime"
                      :current-time="render.currentTime"
                      :levels="levels"
                      :works="works"
                      @click="handleClickCalendarItem"
            />
          </ym-tab>

          <ym-tab name="history" title="打卡历程">
            <work-list v-if="works.length > 0"
                       :works="works"
            />
            <div class="empty"
                 v-else
            >
              暂无打卡历程
            </div>
          </ym-tab>
        </ym-tabs>

        <template #tabbar>
          <bottom-bar :id="training.id"
                      :is-complete="render.isComplete"
                      :is-receive-certificate="render.isReceiveCertificate"
                      :todo-item="todoItem"
                      :share-path="$wechat.getWechatMenuShareAppLink()"
                      @show-detail="handleShowDetail"
          />
        </template>
      </bottom-bar-layout>

    </template>

    <skeleton v-else />
  </div>
</template>

<script>
  import { Tabs, Tab } from '@ymba/ym-ui';
  import BottomBarLayout from '@/layout/BottomBarLayout';
  import Skeleton from '@/skeleton/TrainingDetailJoined';
  import { getJoinedTrainingDetail } from '@/services/training';
  import TrainingHeader from '@/pages/Training/components/TrainingDetailJoinedHeader';
  import Calendar from '@/pages/Training/components/TrainingDetailCalendar';
  import WorkList from '@/pages/Training/components/TrainingDetailWorkList';
  import BottomBar from '@/pages/Training/components/TrainingDetailJoinedBottomBar';

  export default {
    name: 'TrainingDetailJoined',
    components: {
      BottomBarLayout,
      Skeleton,
      TrainingHeader,
      Calendar,
      WorkList,
      'ym-tabs': Tabs,
      'ym-tab': Tab,
      BottomBar,
    },
    data() {
      return {
        bottomBarShadow: false,
        tabSelected: 'calendar',
        levels: [],
        works: [],
        todoItem: {
          id: 0,
          status: '',
          type: '',
        },
        training: {
          id: 0,
          title: '',
        },
        count: {
          continue: 0,
          finish: 0,
          read: 0,
        },
        render: {
          startTime: 0,
          currentTime: 0,
          isComplete: false,
          isReceiveCertificate: false,
        },
        sharePath: {
          type: String,
        },
      };
    },
    methods: {
      async fetchTrainingDetail(id) {
        const data = await getJoinedTrainingDetail(id);

        this.works = data.works;
        this.todoItem = data.todoItem;
        this.training = data.training;
        this.levels = data.levels;
        this.render = data.render;
        this.count = data.count;
      },
      handleClickCalendarItem(item) {
        if (item.status === 'outOfTraining') return;
        if (item.status === 'lock') {
          this.$toast('尚未到打卡时间');
          return;
        }
        if (item.status === 'finished') {
          const route = { name: 'TrainingWorkDetail', params: { id: item.workId } };
          this.$router.push(route);
          return;
        }
        // 去打卡
        const route = { name: 'TrainingLevelDetail', params: { id: item.levelId } };
        this.$router.push(route);
      },
      handleShowDetail() {
        this.$emit('show-detail');
      },
    },
    created() {
      const { id } = this.$route.params;
      this.fetchTrainingDetail(id);
    },
    beforeRouteUpdate(to, from, next) {
      const { id } = to.params;
      this.fetchTrainingDetail(id);
      next();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .training-joined-detail-component {
    background-color: @color-white;
    height: 100%;
    box-sizing: border-box;
  }

  .empty {
    margin-top: @size-base;
  }
</style>
